import { ChartType } from '../Models/Enums';

export function getChartAssets(chartType: ChartType): string {
  const assets = [
    { chartType: ChartType.BAR, asset: './assets/icons/bars-chart.svg' },
    { chartType: ChartType.LINE, asset: './assets/icons/line-chart.svg' },
    { chartType: ChartType.DOT, asset: './assets/icons/dotted-chart.svg' },
    { chartType: ChartType.PIE, asset: './assets/icons/pie-chart.svg' },
    { chartType: ChartType.RADAR, asset: './assets/icons/radar-chart.svg' },
    { chartType: ChartType.DOUGHNUT, asset: './assets/icons/doughnut-chart.svg' },
    { chartType: ChartType.SCATTER, asset: './assets/icons/scatter-chart.svg' },
    { chartType: ChartType.BUBBLE, asset: './assets/icons/dotted-chart.svg' },
    { chartType: ChartType.POLARAREA, asset: './assets/icons/doughnut-chart.svg' },
    { chartType: ChartType.SPLINE, asset: './assets/icons/spline-chart.svg' }
  ];
  return assets.find(x => x.chartType === chartType).asset;
}
